/** Angular */
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
/** Sixense */
import { BydConfigService } from '@sixense/byd-core-service';
/** Interfaces */
import { BydRhsApiConfigInterface } from '../interfaces/byd-rhs-api-config.interface';

@Injectable({
  providedIn: 'root',
})
export class BydRhsHeadersService {
  /**
   * Creates an instance of BydRhsHeadersService.
   *
   * @param bydConfigService the api configuration service
   */
  constructor(protected bydConfigService?: BydConfigService<BydRhsApiConfigInterface>) {}

  /**
   * Sets or modifies a value for the bydConfigService headers.
   * Return a `clone` of the original instance of the bydConfigService headers with a pagination.
   *
   * @param numberPerPage the maximum number of elements returned
   * @param pageIndex the page index, starting at 0 by default
   * @returns HttpHeaders
   */
  public setHeadersWithPagination(numberPerPage = 10, pageIndex = 0): HttpHeaders {
    return this.bydConfigService.headers
      .set('numperpage', numberPerPage.toString())
      .set('pagenumber', (pageIndex + 1).toString());
  }
}
